// import imgLogo from '../../assets/menu_logo.png';
// import imgClose from '../../assets/menu_close.png';
import styles from './Menu.module.scss'
import { buildLabel, BUILD_CHANNEL } from '../../libs/pwaUpdate'
import MenuTopItem from './MenuTopItem'
import MenuTopList, { MenuTopListItem } from './MenuTopList'
import MenuDashboardItem from './MenuDashboardItem'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
   faHouse,
   faGem,
   faPeopleGroup,
   faFileLines,
   faBox,
   faGear,
   faRightFromBracket,
   faGlobe,
   faBitcoinSign,
   faFlaskVial,
   faTriangleExclamation,
   faPersonDigging,
   faTruckMedical,
   faBook,
   faKey,
   faScaleBalanced,
   faObjectGroup,
   faCircleCheck,
   faCircleXmark
} from '@fortawesome/free-solid-svg-icons'
import { faUserTieHairLong, faCloudArrowDown, faBookmark, faWifi, faWifiExclamation, faCloudSlash, faLightEmergencyOn, faUmbrellaBeach } from '@fortawesome/pro-solid-svg-icons'
import { useNavigate } from 'react-router-dom'
import useTranslation from '../../Hooks/useTranslation'
// import useTest from "../Hooks/useTest"
import usePrefStore from '../../stores/prefs'
import { useCallback, useEffect, useState } from 'react'
import useModelsStore from '../../stores/models'
import useHelpers from '../../Hooks/useHelpers'
import useSales from '../../Hooks/useSales'
import useIsRetailOnly from '../../Hooks/useIsRetailOnly'
import { computeRetailRoleForCustomer } from '../../Hooks/useRetailRoleForCustomer'
import useRetailQuota from '../../Hooks/useRetailQuota'
import useIsSingleCustomerLocal from '../../Hooks/useIsSingleCustomerLocal'
import useRetailCatalogScope from '../../Hooks/useRetailCatalogScope'
import { useIsHomeAvailable } from '../../Hooks/useHome'
// import { useLogger } from '../Contexts/Logger';
import { AppWriteContext } from '../../Contexts/AppWriteContext'
import { useLiveQuery } from 'dexie-react-hooks'
import { GlobalContext } from '../../Contexts/GlobalContext'
import Button from '../Button'
import ImpersonationBanner from '../ImpersonationBanner'
import { Switch } from '@mantine/core'
import { useLongPress } from 'use-long-press'
import useTarifs from '../../Hooks/useTarifs'
import moment from 'moment'
import 'moment/dist/locale/fr'
import glob_const from '../../libs/glob_const'

const mailSupport = 'Support Messika<supportome@messikagroup.com>'

const Menu = (props) => {
   const [isLangMenuVisible, setIsLangMenuVisible] = useState(false)
   const [isTarifMenuVisible, setIsTarifMenuVisible] = useState(false)
   const [menuListTarifs, setMenuListTarifs] = useState(null)
   const [menuListRecentCustomers, setMenuListRecentCustomers] = useState(null)
   const [menuListRecentOrders, setMenuListRecentOrders] = useState(null)
   const [tarifIsValid, setTarifIsValid] = useState(true)
   const [strButtonMenuTarif, setStrButtonMenuTarif] = useState(null)
   // const [newVersionReady, setNewVersionReady] = useState(false);
   const [strTimeout, setStrTimeout] = useState<any>()
   //
   // //const lang = usePrefStore((state) => state.currentLang)
   // const setLang = usePrefStore((state) => state.setCurrentLang);
   // const curLang = usePrefStore((state) => state.currentLang)
   // const curTarifRegionName = usePrefStore((state) => state.curTarifRegionName);
   // const setCurTarifRegionName = usePrefStore((state) => state.setCurTarifRegionName);
   // const curTarifCustomer = usePrefStore((state) => state.curTarifCustomer);
   // const curTarifRegion = usePrefStore((state) => state.curTarifRegion);
   // const setCurCustomer = usePrefStore((state) => state.setCurCustomer);
   // const setCurOrder = usePrefStore((state) => state.setCurOrder);
   // const curCustomer = usePrefStore((state) => state.curCustomer);
   // const curOrder = usePrefStore((state) => state.curOrder);
   // const recentCustomers = usePrefStore((state) => state.recentCustomers);
   // const recentOrders = usePrefStore((state) => state.recentOrders);
   // const keepHistoryOpen = usePrefStore((state) => state.keepHistoryOpen);
   // const debug = usePrefStore((state) => state.debug);
   // const setDebug = usePrefStore((state) => state.setDebug);
   const {
      setCurrentLang: setLang,
      currentLang: curLang,
      curTarifRegionName,
      setCurTarifRegionName,
      curTarifCustomer,
      curTarifRegion,
      setCurCustomer,
      setCurOrder,
      curCustomer,
      curOrder,
      recentCustomers,
      recentOrders,
      keepHistoryOpen,
      debug,
      setDebug,
      screenshotMode,
      curTimeout /*, login*/,
      setMissingTarifRegionName,
      appWriteEndpoint,
      serverRetailRole,
      theme,
      setTheme,
      showThemeToggle,
      showTests,
   } = usePrefStore()
   //
   // const tarifNames = useModelsStore((state) => state.tarif_regions);
   // const tarifs = useModelsStore((state) => state.tarifs);
   // const tarif_trads = useModelsStore((state) => state.tarif_trads);
   const { tarif_regions: tarifNames, tarifs, tarif_trads } = useModelsStore()
   //
   const { trans, getLangName } = useTranslation()
   const { getVersion, getVersionDate, formatCESPrice, formatNumber } = useHelpers()
   const { isTarifValid, isCustomerTarifSameAsRegion, isTarifLoadedForRegion } = useTarifs()
   const navigate = useNavigate()
   const {
      getCustomerById,
      getOrdersByIds,
      calcTotalForOrder,
      getItemsCountForOrder,
      updateRecentCustomers,
      updateRecentOrders,
      setCustomerIdAsCurrent,
      setOrderIdAsCurrent,
      isRetailOrder,
      isKOTOrder,
      isKTMOrder,
      getCustomerRetailType,
      canCreateRetailOrder,
      getRetailOrderType,
      getUnsyncOrdersAsArray,
      order_status,
   } = useSales()
   const { customerType: effectiveCt } = useRetailCatalogScope()
   const isRetailOnly = useIsRetailOnly()
   const { canCreateKOT, canCreateKTM } = useRetailQuota()
   const retailRole = usePrefStore((state) => state.retailRole)
   const login = usePrefStore((state) => state.login)
   const userName = usePrefStore((state) => state.userName)
   // Mode "1 seul client en base locale" : on masque le sélecteur de tarif
   // (le tarif est déjà DL et posé par autoSelectSingleCustomer).
   const isSingleCustomer = useIsSingleCustomerLocal()
   // Accueil disponible ? (= ni Grand Utilisateur ni Single Customer)
   const isHomeAvailable = useIsHomeAvailable()
   // Flag isRetailManager (utilisé dans le bloc debug pour le check Cat. BJX).
   const isRetailManager = usePrefStore((state) => state.isRetailManager)
   const supervisedN1 = usePrefStore((state) => state.supervisedN1)
   const supervisedN2 = usePrefStore((state) => state.supervisedN2)
   // Badge "à valider" sur l'item Commandes (N1/N2/admin) : nb de commandes retail en attente de
   // MA validation (même critère que l'onglet "À valider" de la page Orders).
   const isManagerOrAdmin = retailRole === 'admin' || isRetailManager
   const pendingValidationCount = useLiveQuery(async () => {
      if (!isManagerOrAdmin) return 0
      const orders = await getUnsyncOrdersAsArray()
      let count = 0
      for (const o of orders) {
         if (!isRetailOrder(o)) continue
         const r = computeRetailRoleForCustomer(o.customer_id, retailRole, isRetailManager, supervisedN1, supervisedN2)
         if (r.isAdmin) { if (o.status === order_status.wait_n1 || o.status === order_status.wait_n2) count++ }
         else if (r.isN1) { if (o.status === order_status.wait_n1) count++ }
         else if (r.isN2) { if (o.status === order_status.wait_n2) count++ }
      }
      return count
   }, [isManagerOrAdmin, retailRole, isRetailManager, supervisedN1, supervisedN2, order_status])
   const absenceFrom = usePrefStore((state) => state.absenceFrom)
   const absenceTo = usePrefStore((state) => state.absenceTo)
   const hasAbsence = !!(absenceFrom && absenceTo)
   // const { test } = useTest()
   const { doLogout, otp } = { ...AppWriteContext() } as any
   const { isListRecentCustomersVisible, setIsListRecentCustomersVisible, isListRecentOrdersVisible, setIsListRecentOrdersVisible, setIsSyncLayerVisible, setIsOtpLayerVisible, isWebSocketConnected, setIsMissingTarifLayerVisible } = {
      ...GlobalContext()
   } as any
   // const { log } = useLogger();
   const live_orders = useLiveQuery(async () => await getOrdersByIds(recentOrders), [recentOrders])

   useEffect(() => {
      moment.locale(curLang)
      setStrTimeout(moment.unix(curTimeout).fromNow(true))

      const timer = setInterval(() => {
         // console.log('************', timer);
         setStrTimeout(moment.unix(curTimeout).fromNow(true))
      }, 6000) // Chaque minute

      return () => {
         // console.log('************ ClearInterval')
         clearInterval(timer)
      }
   }, [curLang, curTimeout])

   const switchTarif = useCallback(
      (new_tarif) => {
         if (isTarifLoadedForRegion(new_tarif)) {
            setCurTarifRegionName(new_tarif)
         } else {
            setIsMissingTarifLayerVisible(true)
            setMissingTarifRegionName(new_tarif)
         }
         setIsTarifMenuVisible(false)
         setCurCustomer(null)
         setCurOrder(null)
      },
      [isTarifLoadedForRegion, setCurCustomer, setCurOrder, setCurTarifRegionName, setIsMissingTarifLayerVisible, setMissingTarifRegionName]
   )

   useEffect(() => {
      if (!keepHistoryOpen) {
         setIsListRecentCustomersVisible(false)
         setIsListRecentOrdersVisible(false)
      }
   }, [keepHistoryOpen, setIsListRecentCustomersVisible, setIsListRecentOrdersVisible])

   useEffect(() => {
      let is_valid

      if (curCustomer) {
         is_valid = isTarifValid(curTarifRegion) && isTarifValid(curTarifCustomer)
      } else {
         is_valid = isTarifValid(curTarifRegion)
      }
      setTarifIsValid(is_valid)
   }, [isTarifValid, curCustomer, curTarifCustomer, curTarifRegion])

   useEffect(() => {
      let str = null

      // console.log('TAR', tarifNames, curTarifRegion, curTarifRegionName, tarif_trads);

      if (tarifIsValid) {
         let localizedRegionName

         if (curLang === 'en') {
            localizedRegionName = tarif_trads[curTarifRegionName]?.label.en ?? '???'
         } else {
            localizedRegionName = curTarifRegionName ?? '???'
         }
         // if (curTarifCustomer && curTarifRegion &&
         //    ((curTarifCustomer.other.ces.currency !== curTarifRegion.other.ces.currency) ||
         //       (curTarifCustomer.other.ppu.currency !== curTarifRegion.other.ppu.currency))
         if (curTarifCustomer && curTarifRegion && !isCustomerTarifSameAsRegion(curTarifCustomer, curTarifRegion)) {
            str = `${localizedRegionName} (${curTarifCustomer.other.ppu.currency} + ${curTarifCustomer.other.ces.currency})`
         } else {
            str = localizedRegionName
         }
      }
      setStrButtonMenuTarif(str)
   }, [curLang, curTarifCustomer, curTarifRegion, curTarifRegionName, isCustomerTarifSameAsRegion, tarifIsValid, tarif_trads])

   // useEffect(() => {
   //    console.log('***+++CHANGE RECENT', recentOrders)
   // }, [recentOrders])

   // useEffect(() => {
   //    console.log('***+++CHANGE LIVE', live_orders)
   // }, [live_orders])

   useEffect(() => {
      const arr = []
      // console.log(tarifNames);

      for (const name in tarifNames) {
         let label
         const lang = curLang === 'en' ? 'en' : 'fr'
         const element = tarifNames[name]

         // console.log(tarif_trads, name, lang);
         if (lang !== 'en') {
            label = name
         } else {
            label = tarif_trads[name]?.label.en ?? name
         }

         if (element.in_list) {
            arr.push(
               <MenuTopListItem selected={name === curTarifRegionName} key={`tarif_${name}`} onClick={() => switchTarif(name)}>
                  {label}
                  {
                     /*element.preload &&*/
                     tarifs[element.currencies.hjo.ces.tarif] && tarifs[element.currencies.hjo.ppu.tarif] && tarifs[element.currencies.other.ces.tarif] && tarifs[element.currencies.other.ppu.tarif] && (
                        <FontAwesomeIcon style={{ color: 'var(--color-primary-green)' }} icon={faCloudArrowDown} />
                     )
                  }
                  {
                     /*element.preload &&*/
                     (!tarifs[element.currencies.hjo.ces.tarif] || !tarifs[element.currencies.hjo.ppu.tarif] || !tarifs[element.currencies.other.ces.tarif] || !tarifs[element.currencies.other.ppu.tarif]) && (
                        <FontAwesomeIcon style={{ color: 'var(--color-primary-red)' }} icon={faCloudArrowDown} />
                     )
                  }
               </MenuTopListItem>
            )
         }
      }
      setMenuListTarifs(arr)
   }, [curLang, curTarifRegionName, switchTarif, tarifNames, tarif_trads, tarifs])

   const toggleShowDebug = () => {
      setDebug(!debug)
   }

   const longPressOnShowCess = useLongPress(toggleShowDebug, { threshold: 5000 })

   const chooseCustomer = useCallback(
      (customer_id) => {
         setCustomerIdAsCurrent(customer_id)
         updateRecentCustomers(customer_id)
         if (!keepHistoryOpen) {
            setIsListRecentCustomersVisible(false)
         }
         navigate(`/customer-detail?id=${customer_id}`, { replace: false })
      },
      [keepHistoryOpen, navigate, setCustomerIdAsCurrent, setIsListRecentCustomersVisible, updateRecentCustomers]
   )

   const chooseOrder = useCallback(
      (order_id) => {
         setOrderIdAsCurrent(order_id)
         updateRecentOrders(order_id)
         if (!keepHistoryOpen) {
            setIsListRecentOrdersVisible(false)
         }
         navigate(`/order-detail?id=${order_id}`, { replace: false })
      },
      [keepHistoryOpen, navigate, setIsListRecentOrdersVisible, setOrderIdAsCurrent, updateRecentOrders]
   )

   useEffect(() => {
      const arr = recentCustomers.map((id) => {
         const customer_id = id
         const customer = getCustomerById(id)
         const isFakeCust = customer_id?.startsWith(glob_const.prefix_ktm) || customer_id?.startsWith(glob_const.prefix_prospect)

         return (
            <MenuTopListItem key={`customer_${customer_id}`} onClick={isFakeCust ? undefined : () => chooseCustomer(customer_id)}>
               <div className={`${styles.recent_item} ${curCustomer === customer_id ? styles.red : ''}`}>
                  <FontAwesomeIcon icon={faUserTieHairLong} />
                  <div>
                     <span># {customer_id}</span>
                     <span style={isFakeCust ? { fontStyle: 'italic' } : undefined}>{customer?.name ?? '???'}</span>
                  </div>
               </div>
            </MenuTopListItem>
         )
      })
      setMenuListRecentCustomers(arr)
   }, [chooseCustomer, curCustomer, getCustomerById, recentCustomers])

   useEffect(() => {
      // console.log('***+++REBUILD RECENT', recentOrders, live_orders);
      if (live_orders) {
         const arr = recentOrders.map(async (id) => {
            const order_id = id
            const order = live_orders.find((an_order) => an_order.id === id)
            // const customer = await getCustomerById(order?.customer_id)
            const customer = getCustomerById(order?.customer_id)
            const currency = customer?.tarifs.ces.currency // Dans le menu on n'est pas forcément sur le client ou la commande sélectionné(e), on doit donc cibler explicitement la bonne devise
            const totalForOrder = calcTotalForOrder(order)
            const itemsCountForOrder = getItemsCountForOrder(order)
            const isFakeCust = customer?.id?.startsWith(glob_const.prefix_ktm) || customer?.id?.startsWith(glob_const.prefix_prospect)

            return (
               <MenuTopListItem key={`order_${order_id}`} onClick={() => chooseOrder(order_id)}>
                  <div className={`${styles.recent_item} ${curOrder === order_id ? styles.red : ''}`}>
                     <FontAwesomeIcon icon={isKOTOrder(order) ? faScaleBalanced : isKTMOrder(order) ? faObjectGroup : isRetailOrder(order) ? faBox : faFileLines} />
                     <div>
                        <span># {order_id}</span>
                        <span style={isFakeCust ? { fontStyle: 'italic' } : undefined}>{customer?.name ?? '???'}</span>
                        {order?.mark && (
                           <span>
                              <FontAwesomeIcon icon={faBookmark} /> {order.mark}
                           </span>
                        )}
                        <span>
                           {formatCESPrice(totalForOrder, currency)}, {formatNumber(itemsCountForOrder)} {trans('?article', itemsCountForOrder)}
                        </span>
                     </div>
                  </div>
               </MenuTopListItem>
            )
         })
         // console.log('***+++REBUILD RECENT2', arr);
         Promise.all(arr).then((arr) => {
            // console.log('***+++REBUILD RECENT3', arr);
            setMenuListRecentOrders(arr)
         })
      }
   }, [calcTotalForOrder, chooseOrder, curOrder, formatNumber, formatCESPrice, getCustomerById, getItemsCountForOrder, live_orders, recentOrders, trans, isRetailOrder, isKOTOrder, isKTMOrder])

   function goMain() {
      navigate('/', { replace: true })
   }

   function goCatalog() {
      navigate('/catalog', { replace: false })
   }

   function goCustomers() {
      setIsListRecentCustomersVisible(false)
      navigate('/customers', { replace: false })
   }

   function goOrders() {
      setIsListRecentOrdersVisible(false)
      // N1/N2/admin : on ouvre directement l'onglet « À valider » (leur usage principal).
      navigate(isManagerOrAdmin ? '/orders?tab=pending' : '/orders', { replace: true })
   }

   function goParams() {
      navigate('/params', { replace: false })
   }

   // function goTarifs() {
   //    navigate('/tarifs', { replace: true });
   // }

   function goTests() {
      if (process.env.NODE_ENV === 'development') {
         navigate('/tests', { replace: true })
      }
   }

   function goLogout() {
      // navigate("/login", { replace: true })
      doLogout()
   }

   function switchLang(new_lang) {
      setLang(new_lang)
      setIsLangMenuVisible(false)
   }

   function toggleLangVisible() {
      setIsLangMenuVisible((cur) => !cur)
      setIsTarifMenuVisible(false)
      if (!keepHistoryOpen) {
         setIsListRecentCustomersVisible(false)
         setIsListRecentOrdersVisible(false)
      }
   }

   function toggleTarifVisible() {
      setIsTarifMenuVisible((cur) => !cur)
      setIsLangMenuVisible(false)
      if (!keepHistoryOpen) {
         setIsListRecentCustomersVisible(false)
         setIsListRecentOrdersVisible(false)
      }
   }

   function toogleRecentCustomers() {
      console.log(isListRecentCustomersVisible)
      setIsListRecentCustomersVisible((cur) => !cur)
      setIsLangMenuVisible(false)
      setIsTarifMenuVisible(false)
      setIsListRecentOrdersVisible(false)
   }

   function toogleRecentOrders() {
      setIsListRecentOrdersVisible((cur) => !cur)
      setIsLangMenuVisible(false)
      setIsTarifMenuVisible(false)
      setIsListRecentCustomersVisible(false)
   }

   function onConfigTariffs() {
      navigate('/tarifs', { replace: true })
   }

   // function updateApp() {
   //    navigator.serviceWorker.ready.then((registration) => {
   //       registration.update();
   //    });
   // }

   function prepareOfflineMode() {
      console.log('prepareOfflineMode')
      setIsSyncLayerVisible(true)
   }

   const contactSupport = useCallback(() => {
      const supportReqSubjet = trans('?oMe_subject_support')
      // console.log('prepareOfflineMode');
      window.location.href = `mailto:${mailSupport}?subject=${supportReqSubjet.replace(' ', '%20')}`
   }, [trans])

   const showDoc = useCallback(() => {
      window.open(`https://rbv3-docs.messikagroup.com/OME_User_Guide_${curLang === 'en' ? 'GB' : 'FR'}.pdf`, '_blank')
   }, [curLang])

   const showOtp = useCallback(() => {
      setIsOtpLayerVisible(true)
   }, [setIsOtpLayerVisible])

   return (
      <>
         {showThemeToggle && (
            <div className={styles.theme_toggle_layer}>
               <Switch
                  label="Nouveau thème"
                  checked={theme === 'alt'}
                  onChange={(evt) => setTheme(evt.currentTarget.checked ? 'alt' : 'default')}
                  className={styles.theme_toggle}
                  styles={{ label: { color: 'white', fontFamily: 'var(--font-family-plusjakartasans)' } }}
               />
            </div>
         )}
      <div className={styles.menu} {...longPressOnShowCess()}>
         <div className={styles.header}>
            {/* <img src={imgLogo} alt="Logo Messika" onClick={goMain} />
            <button>
               <img src={imgClose} alt="Close menu" />
            </button> */}
            {(appWriteEndpoint.includes('-dev') || appWriteEndpoint.includes('http://')) && <FontAwesomeIcon icon={faPersonDigging} />}
            <img src="/assets/menu_logo.png" alt="Logo Messika" onClick={isHomeAvailable ? goMain : goCatalog} />
            {/* <button>
               <img src="/assets/menu_close.png" alt="Close menu" />
            </button> */}
         </div>
         <div className={styles.top}>
            <MenuTopItem label={trans('?Langue')} icon={<FontAwesomeIcon icon={faGlobe} />} value={getLangName()} hasDropdown dropdownVisible={isLangMenuVisible} onClick={toggleLangVisible} />
            {/* <MenuTopList visible={isLangMenuVisible}> */}
            {isLangMenuVisible && (
               <MenuTopList visible>
                  <MenuTopListItem onClick={() => switchLang('fr')}>{trans('?Français', 1, { lng: 'fr' })}</MenuTopListItem>
                  <MenuTopListItem onClick={() => switchLang('en')}>{trans('?Anglais', 1, { lng: 'en' })}</MenuTopListItem>
               </MenuTopList>
            )}
            {/* Sélecteur de tarif : en mode "1 seul client local" on garde la
                zone (pour info : nom du tarif courant) mais elle n'est plus
                cliquable (pas de chevron, pas d'ouverture du dropdown). */}
            <MenuTopItem
               label={trans('?Tarif')}
               icon={<FontAwesomeIcon icon={tarifIsValid ? faBitcoinSign : faTriangleExclamation} />}
               value={strButtonMenuTarif}
               hasDropdown={!isSingleCustomer}
               dropdownVisible={isTarifMenuVisible}
               onClick={isSingleCustomer ? undefined : toggleTarifVisible}
            />
            {!isSingleCustomer && isTarifMenuVisible && (
               <MenuTopList visible>
                  {menuListTarifs}
                  <Button primary lefticon={<FontAwesomeIcon icon={faGear} />} onClick={onConfigTariffs}>
                     {trans('?Paramétrer')}
                  </Button>
               </MenuTopList>
            )}
         </div>
         <div className={styles.dashboard}>
            <h1>{trans('?Dashboard')}</h1>
            {/* Accueil et Clients masqués en mode "1 seul client local" :
                pas de choix possible / pas de liste à parcourir. */}
            {isHomeAvailable && (
               <MenuDashboardItem icon={<FontAwesomeIcon icon={faHouse} />} selected={props.page === 'Main' ? true : false} onClick={goMain}>
                  {trans('?Accueil')}
               </MenuDashboardItem>
            )}
            <MenuDashboardItem icon={<FontAwesomeIcon icon={isRetailOnly ? faBox : faGem} />} selected={props.page === 'catalog' ? true : false} onClick={goCatalog}>
               {trans('?Catalogue')}
            </MenuDashboardItem>
            {!isSingleCustomer && (
               <>
                  <MenuDashboardItem icon={<FontAwesomeIcon icon={faPeopleGroup} />} hasDropdown dropdownVisible={isListRecentCustomersVisible} selected={props.page === 'customers' ? true : false} onClick={goCustomers} onDropdown={toogleRecentCustomers}>
                     {trans('?Client', true)}
                  </MenuDashboardItem>
                  {isListRecentCustomersVisible && <MenuTopList visible>{menuListRecentCustomers}</MenuTopList>}
               </>
            )}
            <MenuDashboardItem icon={<FontAwesomeIcon icon={faFileLines} />} hasDropdown dropdownVisible={isListRecentOrdersVisible} selected={props.page === 'orders' ? true : false} onClick={goOrders} onDropdown={toogleRecentOrders}>
               {trans('?Commande', true)}
               {!!pendingValidationCount && pendingValidationCount > 0 && (
                  <span className={styles.validation_badge} title={trans('?À valider')}>{pendingValidationCount}</span>
               )}
            </MenuDashboardItem>
            {isListRecentOrdersVisible && <MenuTopList visible>{menuListRecentOrders}</MenuTopList>}
         </div>
         <div className={styles.dashboard}>
            <h1>{trans('?Autre', true)}</h1>
            <MenuDashboardItem icon={<FontAwesomeIcon icon={faGear} />} disabled selected={props.page === 'params' ? true : false} onClick={goParams}>
               {trans('?Paramètres')}
               {hasAbsence && (
                  <FontAwesomeIcon icon={faUmbrellaBeach} style={{ marginLeft: 'auto', color: 'inherit', fontSize: 'var(--font-size-16)' }} title={`Absence du ${absenceFrom} au ${absenceTo} inclus`} />
               )}
            </MenuDashboardItem>
            {/* <MenuDashboardItem icon={<FontAwesomeIcon icon={faCloudArrowDown} />} selected={props.page === 'tarifs' ? true : false} onClick={goTarifs}>
               {trans('?Tarifs')}
            </MenuDashboardItem> */}
            {showTests && (
               <MenuDashboardItem icon={<FontAwesomeIcon icon={faFlaskVial} />} selected={props.page === 'tests' ? true : false} onClick={goTests}>
                  Tests
               </MenuDashboardItem>
            )}
            {/* Préparation offline = pré-chargement de tarifs/clients additionnels —
                sans intérêt en mode "1 seul client local". */}
            {!isSingleCustomer && (
               <MenuDashboardItem icon={<FontAwesomeIcon icon={faCloudSlash} />} onClick={prepareOfflineMode}>
                  {trans('?Préparation offline')}
               </MenuDashboardItem>
            )}
            <MenuDashboardItem icon={<FontAwesomeIcon icon={faTruckMedical} />} onClick={contactSupport}>
               {trans('?Support')}
            </MenuDashboardItem>
            <MenuDashboardItem icon={<FontAwesomeIcon icon={faBook} />} onClick={showDoc}>
               {trans('?Documentation')}
            </MenuDashboardItem>
            {otp && (
               <MenuDashboardItem icon={<FontAwesomeIcon icon={faKey} />} onClick={showOtp}>
                  {trans('?Mot de passe unique')}
                  <FontAwesomeIcon icon={faLightEmergencyOn} className={styles.redicon} />
               </MenuDashboardItem>
            )}
            {/* Bloc DEBUG : masqué quand screenshotMode est ON, mais le rôle
                retail sélectionné reste actif (debug reste à true). */}
            {glob_const.retail_enabled &&
               debug && !screenshotMode &&
               (() => {
                  const customer = curCustomer ? getCustomerById(curCustomer) : null
                  const customerCt = getCustomerRetailType(customer)
                  // effectiveCt vient du même helper que le catalogue → garantit l'alignement
                  // entre ce qu'on affiche dans le debug et ce que voit l'utilisateur.
                  // Cf. règle complète dans Catalog.tsx (showJewelryCatalog).
                  const isClientServer = serverRetailRole === 'client'
                  // Niveau de supervision (N1/N2) du user vis-à-vis du client courant.
                  // N1/N2 n'est pas global : dépend du customer (listes supervisedN1/N2).
                  const roleForCustomer = computeRetailRoleForCustomer(curCustomer, retailRole, isRetailManager, supervisedN1, supervisedN2)
                  const niveauSupervision = roleForCustomer.isAdmin
                     ? 'admin'
                     : roleForCustomer.isN1
                        ? 'N1'
                        : roleForCustomer.isN2
                           ? 'N2'
                           : (isRetailManager ? 'manager (aucun sur ce client)' : 'aucun')
                  const seeBJX = retailRole === 'admin' ? true : (!isClientServer && !isRetailManager)
                  const seeRET = effectiveCt !== 'NONE'
                  const retailOrderType = getRetailOrderType(customer)
                  const canRetail = canCreateRetailOrder(customer)
                  // KOT/KTM per-customer (KOT = pour CE customer ; KTM = global, peut créer si N1 d'au moins un customer)
                  const kot = canCreateKOT(customer?.id)
                  const ktm = canCreateKTM()
                  const yes = <FontAwesomeIcon icon={faCircleCheck} style={{ color: '#2ecc40' }} />
                  const no = <FontAwesomeIcon icon={faCircleXmark} style={{ color: '#c00' }} />
                  return (
                     <div className={styles.retail_role}>
                        <span className={styles.debug_label}>MODE DEBUG</span>
                        <span className={`${styles.retail_role_info} ${styles.debug_login_line}`}><span className={styles.debug_login_value}>{buildLabel()}</span></span>
                        {(userName || login) && <span className={`${styles.retail_role_info} ${styles.debug_login_line}`}><span className={styles.debug_login_value}>{userName || login}</span></span>}
                        <span className={styles.retail_role_info}>Rôle serveur : {serverRetailRole ?? 'aucun'}</span>
                        <span className={styles.retail_role_info}>Niveau (client courant) : {niveauSupervision}</span>
                        <span className={styles.retail_role_info}>Client courant : {customer ? (customerCt ?? 'non retail') : 'aucun'}</span>
                        <span className={styles.retail_role_info}>Dépôt retail : {customer ? (customer.depot_retail ?? 'aucun') : '—'}</span>
                        {(() => {
                           // Zone géo (010..070) + scope group/filiale (dérivé de groupe_client) — utiles pour
                           // tracer les droits ECR/ECF posés par la matrice retail_rules.
                           const zoneCode = customer?.zone_geo ?? null
                           const zoneLabel = zoneCode ? (glob_const.geo_zones?.[zoneCode]?.label ?? zoneCode) : null
                           const grpCode = customer?.groupe_client ?? null
                           const grpEntry = grpCode ? glob_const.customer_groups?.[grpCode] : null
                           const scopeStr = grpEntry ? (grpEntry.scope === 'group' ? 'Groupe' : 'Filiale') : null
                           return (
                              <>
                                 <span className={styles.retail_role_info}>Zone géo : {customer ? (zoneLabel ? `${zoneCode} — ${zoneLabel}` : 'aucune') : '—'}</span>
                                 <span className={styles.retail_role_info}>Scope client : {customer ? (scopeStr ? `${grpCode} — ${scopeStr}` : 'aucun') : '—'}</span>
                              </>
                           )
                        })()}
                        <div className={styles.retail_perms}>
                           <span>Cat. BJX&nbsp;? {seeBJX ? yes : no}</span>
                           <span>Cat. RET&nbsp;? {seeRET ? yes : no}</span>
                           <span>Cde RET&nbsp;? {canRetail ? <>{yes} ({retailOrderType})</> : no}</span>
                           <span>KOT&nbsp;? {kot ? yes : no}</span>
                           <span>KTM&nbsp;? {ktm ? yes : no}</span>
                        </div>
                     </div>
                  )
               })()}
         </div>
         <div className={styles.footer}>
            {/* {newVersionReady &&
               <span>Nouvelle version... Quitter</span>
            } */}
            <ImpersonationBanner />
            <MenuDashboardItem icon={<FontAwesomeIcon icon={faRightFromBracket} />} onClick={goLogout}>
               {trans('?Se déconnecter')}
            </MenuDashboardItem>
         </div>
         {/* <div className={styles.login_info}>
            <span>[ {login} ]</span>
         </div> */}
         <div className={styles.session}>
            <span>
               {trans('?Fin de session dans')} {strTimeout}
            </span>
         </div>
         <div className={styles.version}>
            <div className={styles.websocket}>
               <FontAwesomeIcon icon={isWebSocketConnected ? faWifi : faWifiExclamation} className={isWebSocketConnected ? styles.green : styles.red} />
            </div>
            <span>Ver. : {getVersion()}</span>
            <span>{getVersionDate()}</span>
            <span>Ch. {BUILD_CHANNEL}</span>
            {/* <span>SW : {getSWVersion()}</span> */}
         </div>
      </div>
      </>
   )
}

export default Menu
